<template>
  <div id="signContract_warpper">
    <div class="contentBox">
      <div id="contidract" ref="contidract">
        <div :style="pdfStyle" ref="pdfbox">
          <pdf
            v-for="i in numPages"
            :key="i"
            :src="pdfSrc"
            :page="i"
            ref="pdfs"
            @loaded="pdfLoaded(i)"
            :style="{ width: '100%' }"
          >
          </pdf>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
  name: "signContract",
  data() {
    return {
      pdfSrc: "",
      pdfStyle: { "transform-origin": "right top" },
      numPages: undefined,
    };
  },
  created() {
    this.pdfSrc = this.$route.fullPath.replace(
      "/purchaseSupplier/pdf?pdfSrc=",
      ""
    );
    this.pdfSrc = decodeURIComponent(this.pdfSrc);
    if (this.pdfSrc && this.pdfSrc.startsWith("http")) {
      this.pdfSrc = location.protocol + "//" + this.pdfSrc.split("//")[1];
    }
    if (this.pdfSrc) {
      this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
      this.pdfSrc.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
    }
  },
  components: {
    pdf,
  },
  methods: {
    async pdfLoaded(i) {
      // not last page
      if (this.numPages !== i) {
        return;
      }
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less">
#signContract_warpper {
  box-sizing: border-box;
  background-color: #fff;
  min-height: 100%;
  font-size: 16px;

  #contidract {
    &::-webkit-scrollbar {
      display: none;
    }
    overflow: scroll;
    position: relative;
  }
}
</style>
